<section class="locations">
  <div class="container">
    <app-section-title title="Our Location on Clear Lake" alignment="center" theme="dark">
    </app-section-title>

    <div class="locations-grid" [class.single-location]="locations.length === 1">
      <div class="location-card" *ngFor="let location of locations">
        <div class="image-box">
          <img
            [src]="location.image"
            [alt]="location.title"
            [title]="location.title"
            loading="lazy"
          />
        </div>
        <div class="info-box">
          <h3 class="location-title">{{ location.title }}</h3>
          <p class="location-desc">{{ location.description }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
